import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = { class: "lp-savings-calculator" }
const _hoisted_3 = { class: "row g-lg-4" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "mb-3 mb-lg-4" }
const _hoisted_6 = { class: "mb-3 mb-lg-4" }
const _hoisted_7 = { class: "mb-3 mb-lg-4" }
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = { class: "mb-3 mb-lg-4" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "calculator__result-row" }
const _hoisted_12 = { class: "calculator-result-row__number" }
const _hoisted_13 = { class: "calculator__result-row" }
const _hoisted_14 = { class: "calculator-result-row__number" }
const _hoisted_15 = { class: "calculator__result-row" }
const _hoisted_16 = { class: "calculator-result-row__number" }
const _hoisted_17 = { class: "calculator__total" }
const _hoisted_18 = { class: "calculator-total__number" }
const _hoisted_19 = { class: "lp-calculator-disclaimer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_group_input = _resolveComponent("base-group-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["card", _ctx.cssClass])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_base_group_input, {
                  "required-flag": true,
                  inputLabel: "Initial Deposit",
                  "front-group": "$"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_input, {
                      label: "Initial Deposit",
                      modelValue: _ctx.initialDeposit,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.initialDeposit) = $event)),
                      modelModifiers: { number: true },
                      type: "number",
                      placeholder: "10000",
                      "show-label": false
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_base_group_input, {
                  inputLabel: "Monthly Contribution",
                  "front-group": "$",
                  "required-flag": true
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_input, {
                      label: "Monthly Contribution",
                      modelValue: _ctx.monthlyContribution,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.monthlyContribution) = $event)),
                      modelModifiers: { number: true },
                      type: "number",
                      placeholder: "1000",
                      "show-label": false
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[6] || (_cache[6] = _createElementVNode("label", {
                  for: "period-of",
                  class: "form-label"
                }, [
                  _createTextVNode(" Over a period of "),
                  _createElementVNode("span", null, "*")
                ], -1)),
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "form-control",
                    name: "period-of",
                    id: "period-of",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.periodDisplay) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.periodDisplay]
                  ]),
                  _createElementVNode("button", {
                    class: _normalizeClass(["btn btn-outline-secondary", { active: _ctx.isMonths }]),
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.setIsMonths(true)), ["prevent"]))
                  }, " Months ", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["btn btn-outline-secondary", { active: !_ctx.isMonths }]),
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.setIsMonths(false)), ["prevent"]))
                  }, " Years ", 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_base_group_input, {
                  "required-flag": true,
                  inputLabel: "Interest Rate",
                  "back-group": "%"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_input, {
                      label: "Interest Rate",
                      modelValue: _ctx.interestRateHandler,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.interestRateHandler) = $event)),
                      modelModifiers: { number: true },
                      type: "number",
                      placeholder: "0.5",
                      "show-label": false
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "calculator-result-row__dot bg-transparent" }, null, -1)),
                _cache[8] || (_cache[8] = _createElementVNode("p", { class: "calculator-result-row__label" }, "Interest Earned", -1)),
                _createElementVNode("p", _hoisted_12, [
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.formatCurrency(_ctx.interestEarned)), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "calculator-result-row__dot bg-transparent" }, null, -1)),
                _cache[10] || (_cache[10] = _createElementVNode("p", { class: "calculator-result-row__label" }, "Total Contributions", -1)),
                _createElementVNode("p", _hoisted_14, [
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.formatCurrency(_ctx.totalContributionAmount)), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "calculator-result-row__dot bg-transparent" }, null, -1)),
                _cache[12] || (_cache[12] = _createElementVNode("p", { class: "calculator-result-row__label" }, "Initial Deposit", -1)),
                _createElementVNode("p", _hoisted_16, [
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.formatCurrency(_ctx.initialDeposit)), 1)
                  ])
                ])
              ]),
              _cache[15] || (_cache[15] = _createElementVNode("hr", null, null, -1)),
              _createElementVNode("div", _hoisted_17, [
                _cache[14] || (_cache[14] = _createElementVNode("p", null, "Your total savings", -1)),
                _createElementVNode("div", _hoisted_18, [
                  _cache[13] || (_cache[13] = _createElementVNode("span", null, "$", -1)),
                  _createElementVNode("p", null, _toDisplayString(_ctx.total.toLocaleString()), 1)
                ])
              ])
            ])
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("hr", null, null, -1))
        ]),
        _renderSlot(_ctx.$slots, "cta")
      ])
    ], 2),
    _createElementVNode("div", _hoisted_19, [
      _renderSlot(_ctx.$slots, "disclaimer")
    ])
  ], 64))
}